<script lang="ts" setup>
const documentId = inject("documentId") as any;

const isExporting = ref(false);

const copyToClipboard = async () => {
  isExporting.value = true;

  await useExportLoadedDocument(documentId, ExportDocumentFormat.clipboard);

  isExporting.value = false;
};
</script>

<template>
  <BaseTextButton @click.stop.prevent="copyToClipboard" :show-spinner="isExporting">
    <div class="flex flex-row items-center justify-start w-full">
      <icon name="material-symbols:file-copy-outline-sharp" class="mr-2" />
      <span class="block"> Copy to Clipboard </span>
    </div>
  </BaseTextButton>
</template>

<style scoped></style>
